module.exports = __webpack_public_path__ + "img/Talk Graphic 6.d548c341.png";